import { ref, type Ref } from 'vue';
import { vitrineCardApi } from '@/api/vitrineCard';
import { getActivePinia } from 'pinia';
import { useAuthStore } from '@/stores/auth';

/**
 * The signed-in client's first name, shared — the concierge's first chat line greets the client by name
 * («Здравствуйте, Анна!»). Null until known, and stays null when the profile has no name or the call fails: the
 * greeting then reads without a name. Keyed by the signed-in customer: on a shared device the next client (after a
 * logout or a magic-link switch) must never be greeted with the previous client's name.
 */
const firstName = ref<string | null>(null);
let requestedFor: string | null = null;

export function useClientFirstName(): Ref<string | null> {
  // No store outside an app (isolated component tests): no signed-in client, so no name — the greeting reads without it.
  const customerId = getActivePinia() ? (useAuthStore().customerId ?? null) : null;
  if (customerId !== requestedFor) {
    firstName.value = null;
    requestedFor = customerId;
    if (customerId) {
      vitrineCardApi.me()
        .then(p => { if (requestedFor === customerId) firstName.value = p.firstName?.trim() || null; })
        .catch(() => { if (requestedFor === customerId) requestedFor = null; });
    }
  }
  return firstName;
}
